export default __webpack_public_path__ + "static/media/history-temple.5a8f7ddd.png";